export const API_URL = "https://api.pmxchange.co/api/";
//export const API_URL = "https://localhost:5009/api/";
// export const API_URL = "https://localhost:5009/api/";
//lotfan const bala pak nashavad
export const SERVER_URL = "https://api.pmxchange.co/";
export const VERSION = "1.3.3";
